import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getDelays = async (
  startDate?: Date,
  endDate?: Date,
  delayAreaAssetId?: number | null,
  includeMicrodelays: boolean = false,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  if (startDate) {
    parameters.push({ name: "StartDate", value: startDate });
  }
  if (endDate) {
    parameters.push({ name: "EndDate", value: endDate });
  }
  if (delayAreaAssetId !== null && delayAreaAssetId !== undefined) {
    parameters.push({ name: "DelayAreaAssetId", value: delayAreaAssetId });
  }

  parameters.push({ name: "IncludeMicrodelays", value: includeMicrodelays });
  return await apiService.callV2("[DEL].[GetDelays]", parameters, signal);
};

export const getDelayAreas = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  return await apiService.callV2("[DEL].[GetDelayAreas]", parameters);
};
